import type { ContentfulNavQuickLinkFragment } from '@/graphql/contentful/api';

import { useHandleQuickLink } from '../NavQuickLinkItem/helpers';

import * as S from './NavQuickLinkExhibitionsItem.styles';
export interface NavQuickLinkExhibitionsItemProps extends ContentfulNavQuickLinkFragment {
  className?: string;
  isSwiperActive?: boolean;
}

export const NavQuickLinkExhibitionsItem = ({
  backgroundColor,
  className,
  isSwiperActive = false,
  url,
  urlTarget,
  urlText,
  urlTrigger,
}: NavQuickLinkExhibitionsItemProps) => {
  const { handleQuickLink } = useHandleQuickLink(
    url ?? '/',
    urlTarget ?? '_self',
    urlTrigger,
  );
  return (
    <>
      <S.DesktopWrapper smVisible>
        <S.Wrapper
          $backgroundColor={backgroundColor as string}
          className={className}
          data-testid='NavQuickLinkExhibitionsItemWrapper'
          onClick={handleQuickLink}
        >
          <S.LabelBox
            $backgroundColor={backgroundColor as string}
            $isActive={isSwiperActive}
          >
            <S.Label data-testid='NavQuickLinkExhibitionsItemLabel'>
              {urlText}
            </S.Label>
          </S.LabelBox>
        </S.Wrapper>
      </S.DesktopWrapper>
      <S.MobileWrapper smHidden>
        <S.MobileExhibitionWrapper
          $isActive={isSwiperActive}
          className={className}
          data-testid='NavQuickLinkExhibitionsItemWrapper'
          onClick={handleQuickLink}
        >
          <S.MobileLabel
            $backgroundColor={backgroundColor as string}
            data-testid='NavQuickLinkExhibitionsItemLabel'
          >
            {urlText}
          </S.MobileLabel>
        </S.MobileExhibitionWrapper>
      </S.MobileWrapper>
    </>
  );
};
